<template>
  <div>
    <DocumentationLanguage></DocumentationLanguage>
    <DocumentationHeader></DocumentationHeader>
    <DocumentationDemo></DocumentationDemo>
    <PerformanceCharts :isEnglish="false"></PerformanceCharts>
    <DocumentationFeatures></DocumentationFeatures>
    <DocumentationContribute></DocumentationContribute>
    <DocumentationFooter></DocumentationFooter>
  </div>
</template>

<script>
  import DocumentationLanguage from './ch/DocumentationLanguage'
  import DocumentationHeader from './ch/DocumentationHeader'
  import DocumentationDemo from './ch/DocumentationDemo'
  import DocumentationFeatures from './ch/DocumentationFeatures'
  import DocumentationContribute from './ch/DocumentationContribute'
  import DocumentationFooter from './ch/DocumentationFooter'
  import PerformanceCharts from './PerformanceCharts'

  export default {
    name: "DocumentationCh",
    components: {
      PerformanceCharts,
      DocumentationLanguage,
      DocumentationHeader,
      DocumentationDemo,
      DocumentationFeatures,
      DocumentationContribute,
      DocumentationFooter,
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DocumentationCh.vue